import Select from "../solid-forms/Select";
import IconSearch from "../icons/IconSearch";

// Select.jsx's placeholder <option> has no value attribute, so selecting it
// yields the placeholder's own label text as e.target.value. For numeric
// filters that would parse to NaN, so guard it back to "" (no filter).
function parseSelectValue(value, numeric) {
    if (!numeric) return value;
    if (value === "") return "";
    const parsed = Number(value);
    return Number.isNaN(parsed) ? "" : parsed;
}

// Generic, declarative filter bar: a search box, any number of select/date
// filters, an optional sort select, and a result count. Reusable across any
// list page - describe what you need via props instead of hardcoding fields.
export default function FilterBar({ search, filters = [], sort, resultCount }) {
    return (
        <div className="conv-filters-bar">
            {search ? (
                <div className="conv-filters-search">
                    <IconSearch />
                    <input
                        className="conv-filters-search-input"
                        placeholder={search.placeholder || "Пошук..."}
                        value={search.value}
                        onChange={(e) => search.onChange(e.target.value)}
                    />
                    {search.value ? (
                        <div className="conv-filters-search-clear" onClick={() => search.onChange("")}>
                            ×
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            ) : (
                ""
            )}

            {filters.map((filter) =>
                filter.type === "date" ? (
                    <label className="conv-filters-date" key={filter.key}>
                        <span>{filter.label}</span>
                        <input
                            type="date"
                            value={filter.value}
                            onChange={(e) => filter.onChange(e.target.value)}
                            onClick={(e) => e.target.showPicker?.()}
                        />
                    </label>
                ) : (
                    <Select
                        key={filter.key}
                        options={filter.options}
                        info={filter.label}
                        handleInputChange={(value) => filter.onChange(parseSelectValue(value, filter.numeric))}
                        className="submit-field form-selection txt-c select-modal"
                        fieldName="name"
                        disabled={false}
                        value={filter.value}
                        inputName={filter.key}
                    />
                )
            )}

            {sort ? (
                <Select
                    options={sort.options}
                    info={sort.label || "Сортування"}
                    handleInputChange={(value) => sort.onChange(value)}
                    className="submit-field form-selection txt-c select-modal"
                    fieldName="name"
                    disabled={false}
                    value={sort.value}
                    inputName="sort"
                />
            ) : (
                ""
            )}

            {resultCount != null ? <span className="conv-filters-count">Знайдено: {resultCount}</span> : ""}
        </div>
    );
}
